import { UserDocumentDto } from '@ringo/shared'
import axios from 'axios'

export const fileHelper = {
    isImage: (file: UserDocumentDto) => {
        return file.contentType === 'image/jpeg' || file.contentType === 'image/png'
    },
}

export const downloadBlob = (file: Blob, fileName: string) => {
    let anchor = document.createElement('a')
    document.body.appendChild(anchor)
    let objectUrl = window.URL.createObjectURL(file)
    anchor.href = objectUrl
    anchor.download = fileName
    anchor.click()
    window.URL.revokeObjectURL(objectUrl)
}

export const downloadFileFromUrl = (url: string) => {
    const link = document.createElement('a')
    link.target = '_blank'
    link.href = url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const downloadFile = (url: string, fileName: string) => {
    let anchor = document.createElement('a')
    document.body.appendChild(anchor)
    axios
        .get(url, {
            responseType: 'blob',
        })
        .then((response) => {
            let objectUrl = window.URL.createObjectURL(response.data)
            anchor.href = objectUrl
            anchor.download = fileName
            anchor.click()
            window.URL.revokeObjectURL(objectUrl)
        })
}

export function base64ToBlob(base64: string, mimeType: string) {
    const byteCharacters = atob(base64.split(',')[1])
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)

    return new Blob([byteArray], { type: mimeType })
}

// Define the type for the data
interface Data {
    [key: string]: string | number | null
}

// Function to convert object array to CSV
export function objectToCSV<T extends Data>(objArray: T[]): string {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray as any) : objArray
    let str = ''

    // Extract the headers
    const headers = Object.keys(array[0]).join(',')
    str += headers + '\r\n'

    // Extract the data rows
    array.forEach((obj: any) => {
        const line = Object.values(obj)
            .map((value) => `"${value}"`)
            .join(',')
        str += line + '\r\n'
    })

    return str
}

// Function to download CSV file
export function downloadCSV(csvString: string, filename: string): void {
    const blob = new Blob([csvString], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
